import { ReactNode } from "react";
import { ButtonVariants } from "../../../../shared/Button";
import { LinkButton } from "../../../../elements/LinkButton";
import { styles } from "./TextContent.style";

export interface ITextContentProps {
  title?: string;
  ctaLabel?: string;
  ctaLink?: string;
  withImage?: boolean;
  children: ReactNode;
}

export function TextContent({ title, ctaLabel, ctaLink, withImage = false, children }: ITextContentProps) {
  const showCta = ctaLabel && ctaLink;

  return (
    <div className={styles.contentWrapper(withImage)}>
      {title && <h2>{title}</h2>}
      <div className={styles.textWrapper(title)}>{children}</div>
      {showCta && (
        <div className={styles.buttonWrapper()}>
          <LinkButton variant={ButtonVariants.Outlined} href={ctaLink}>
            {ctaLabel}
          </LinkButton>
        </div>
      )}
    </div>
  );
}
